import React from "react";
import { message, Modal, Button, Alert } from "antd";
import "./SendMoneyPage_new.scss";

import SetupPaymentTab from "./SetupPaymentTab_new";
import SetupBeneficiaryTab from "./SetupBeneficiaryTab";
import MakePaymentTab from "./MakePaymentTab";
import PaymentCompletedTab from "./PaymentCompletedTab";
import SetupSourceOfFundsTab from "./SetupSourceOfFundsTab";
import ConfirmPaymentTab from "./ConfirmPaymentTab";
import LoadingIndicator from "components/LoadingIndicator";
import { getSearchParamValueByName, displayNumberWithComma } from "utils/utils";

import { displayGenericError } from "common/notifications";
import {
  lockExchangeRate, createOrder, uploadInvoice,
  getCurrentCustomer
} from "api/api";
import { Link, Redirect } from "react-router-dom";
import { displayError, displayWarningMessage } from "../../common/notifications";
import { renewAccessToken } from "../../api/api";
import CompliancePersonalInfoStatus from "../../components/modal/CompliancePersonalInfoStatus";
import CustomRxPageHeader from "../../rxcomponents/CustomRxPageHeader";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import ProgressBar from './ProgressBar_new';

const TAB_GROUP = {
  'tab-setup-amount': 0, // Create
  'tab-setup-beneficiary': 1, // Recipient
  'tab-setup-source-of-funds': 2, // Details
  'tab-confirm-payment': 3, // Confirm
  'tab-make-payment': 4, // Pay
  'tab-payment-completed': 4, // Pay
};

class SendMoneyPage extends React.Component {
  state = {
    activeTab: "tab-setup-amount",
    payment: null,
    beneficiary: null,
    key: 0,
    order: {},
    accountStatus: null,
    visible: false,
    isSaved: false,
    orderStatus: "",
    visibility: "visible",
    currentCustomer: null,
    errorMsg: '',
    selectedOriginatorVAId: null,
    selectedBeneficiaryVAId: null,
    compliancePersonalInfoStatusVisible: false,
    disableContinue: false,
    checkValidPayment: false,
  };

  componentDidMount() {
    this.loadCurrentCustomer();
    this.renewAccessToken();
  }

  displayConfirmPage = (customer) => {
    this.setState({
      compliancePersonalInfoStatusVisible: !customer.verifiedConfirmStatus && customer.status === 'VERIFIED'
    })
  }

  rejectConfirmPage = () => {
    const intl = this.props.useIntl;
    displayError(intl.formatMessage({ id: "app.message.sendmoneypage.contactbrdgxteam" }));
    this.props.handleLogout("/", "success", "Logout")
  }

  acceptConfirmPage = () => {
    this.setState({
      compliancePersonalInfoStatusVisible: false
    })
  }

  renewAccessToken = () => {
    const intl = this.props.useIntl;
    renewAccessToken(localStorage.getItem("ACCESS_TOKEN")).then(response => {
      localStorage.setItem("ACCESS_TOKEN", response.accessToken);
    }).catch(error => {
      if (error.status === 401) {
        localStorage.removeItem("ACCESS_TOKEN");
        this.props.handleLogout("/", "success", intl.formatMessage({ id: "app.message.sessiontimeout" }));
      }
    })
  }

  componentWillUnmount() {
    localStorage.removeItem("order");
  }

  loadCurrentCustomer = () => {
    const intl = this.props.useIntl;
    return getCurrentCustomer()
      .then(response => {
        const accountStatus = response.status;
        const currentStep = getSearchParamValueByName("currentStep");
        const currentCustomer = response;
        let readOnlyRole = response.roleResources.find(item => item.name === 'READONLY');
        currentCustomer.readOnly = readOnlyRole ? true : false;
        this.displayConfirmPage(currentCustomer)
        currentCustomer.isPartner = (response['customerTierName'] && response['customerTierName'].includes('PARTNER'));
        if (accountStatus === 'UNVERIFIED' && localStorage.getItem("FIRST_TIME_LOGIN") == null) {
          localStorage.setItem("FIRST_TIME_LOGIN", "NO");
          displayWarningMessage(intl.formatMessage({ id: "app.message.sendmoneypage.profilenotverified" }));
        }
        this.setState({
          accountStatus,
          visible:
            accountStatus !== "VERIFIED" && currentStep === "make-payment"
              ? true
              : false,
          activeTab:
            currentStep === "make-payment"
              ? "tab-make-payment"
              : "tab-setup-amount",
          visibility:
            accountStatus !== "VERIFIED" && currentStep === "make-payment"
              ? "hidden"
              : "visible",
          currentCustomer
        });
      })
      .catch(error => {
        displayGenericError(error);
      });
  };

  validationTransactionLimitation = (payment) => {
    let transactionLimitations = payment.transactionLimitation.filter(s => s.currency === payment.targetValue.currency);
    if (transactionLimitations.length > 0) {
      let transactionLimitation = transactionLimitations[0];
      let targetAmount = payment.targetValue.amount;
      if (targetAmount !== '' && this.state.currentCustomer != null) {
        if (this.state.currentCustomer.personalAccountDetails != null) {
          return {
            result: (targetAmount <= transactionLimitation.individualMax && targetAmount >= transactionLimitation.individualMin),
            max: transactionLimitation.individualMax,
            min: transactionLimitation.individualMin,
          };
        } else {
          return {
            result: (targetAmount <= transactionLimitation.corporateMax && targetAmount >= transactionLimitation.corporateMin),
            max: transactionLimitation.corporateMax,
            min: transactionLimitation.corporateMin,
          };
        }
      }
    }
    return { result: true, max: '' };
  };
  toCheckValidPayment = () =>{
    this.setState({
      checkValidPayment: true
    })
 }
  checkValidPayment = payment => {
    const intl = this.props.useIntl;
    let errorMsg = '';

    let exchangeRateElement = payment.exchangeRates[payment.sourceValue.currency][payment.targetValue.currency];
    if (!exchangeRateElement) {
      errorMsg = intl.formatMessage({ id: "app.panel.transferdetailspanel.service.unavailable" }, {
        source: payment.sourceValue.currency,
        target: payment.targetValue.currency
      });
      if(this.state.checkValidPayment){
        this.setState({
          errorMsg: errorMsg,
          disableContinue: true
        })
      }else{
        this.setState({
          disableContinue: true
        })
      }

    } else {
      if (payment.targetValue.amount <= 0 || payment.targetValue.amount === '') {
        errorMsg = intl.formatMessage({ id: "app.message.sendmoneypage.recipientamountnotvalid" });
        // this.setState({
        //   errorMsg: errorMsg,
        //   disableContinue: true
        // })

        if(this.state.checkValidPayment){
          this.setState({
            errorMsg: errorMsg,
            disableContinue: true
          })
        }else{
          this.setState({
            disableContinue: true
          })
        }
      } else {
        this.setState({
          errorMsg: '',
          disableContinue: false
        })
      }
    }
  }

  updatePayment = payment => {
    this.setState({
      payment: payment
    })
  }

  onPaymentSetup = payment => {
    const intl = this.props.useIntl;
    let errorMsg = '';
    if (payment.targetValue.amount < 0 || payment.targetValue.amount === '') {
      errorMsg = intl.formatMessage({ id: "app.message.sendmoneypage.recipientamountnotvalid" });
      this.setState({
        errorMsg: errorMsg
      })
    } else {
      if (this.state.accountStatus !== 'VERIFIED') {
        let errorMsg1 = intl.formatMessage({ id: "app.message.sendmoneypage.youarenotverified" });
        errorMsg += errorMsg1 + "<br><br>" +
          "<div style='text-align: center;'>" +
          "<button style='background-color: #0A9EB2; color: white; padding: 10px 20px; border: none; border-radius: 4px; cursor: pointer; text-decoration: none; display: inline-block; font-size: 14px; margin: 4px 2px;' onclick=\"location.href='/pages/onboarding'\">Verify Your Account</button></div>" +
          "<br>For further support, please contact us at " +
          "<a href='mailto:operations@brdgx.com'>operations@brdgx.com</a> or reach us on WhatsApp at " +
          "<a href='https://wa.me/6591729552'>+65 91729552</a>" +
          "<br><br>Our customer success team could also assist you on payment matters or pricing.";
        displayError(errorMsg);
      } else {
        errorMsg = '';
        this.setState({
          payment: payment,
          errorMsg: errorMsg,
          activeTab: "tab-setup-beneficiary"
        }, () => {
          let requestedAmount = this.state.payment.sourceValue.amount;
          lockExchangeRate(
            this.state.payment.sourceValue.currency,
            this.state.payment.targetValue.currency,
            requestedAmount,
            this.state.payment.beneficiaryType,
            this.state.payment.senderType,
            this.state.payment.beneficiaryCountry,
            this.state.payment.transferMode === "SOURCE" ? null : this.state.payment.convertedAmount,
            this.state.payment.activeTabFee,
            this.state.payment.swiftFee,
          )
            .then(response => {
              this.setState({
                isLoading: false,
                lockedExchangeRate: response
              });
            })
            .catch(error => {
              this.setState({
                isLoading: false
              });
              displayGenericError(error);
            });
        });
      }
    }
  };

  onDoAnotherTransferClicked = () => {
    this.setState({
      activeTab: "tab-setup-amount",
      key: this.state.key + 1,
      payment: null,
      beneficiary: null
    });
    localStorage.removeItem("order");
  };

  onReturnToManageOrderClicked = () => {
    this.setState({
      activeTab: "tab-setup-amount",
      key: this.state.key + 1,
      payment: null,
      beneficiary: null
    });
    this.props.history.push("/pages/order");
  };

  onPaymentDetailsCompleted = (purposeOfTransfer, referenceText, internalReference, invoiceFileName) => {
    this.setState({
      purposeOfTransfer: purposeOfTransfer,
      referenceText: referenceText,
      internalReference: internalReference,
      invoiceFileName: invoiceFileName
    }, () => {
      this.selectTab("tab-confirm-payment");
    });
  };

  handleCreateOrderSuccess = response => {
    const intl = this.props.useIntl;
    let payment = this.state.payment;

    payment.sourceValue.amount = response.sourceAmount;
    payment.targetValue.amount = response.targetAmount;
    this.setState({
      isLoading: false,
      order: response,
      payment: payment
    });

    if (this.state.accountStatus === "VERIFIED") {
      if (this.state.currentCustomer.isPartner) {
        window.location.pathname = "/pages/order";
        return;
      }
      this.selectTab("tab-make-payment");
    } else {
      this.selectTab("tab-setup-amount");
      message.success(intl.formatMessage({ id: "app.message.sendmoneypage.ordersaved" }));
    }
  };

  handleCreateOrderFailed = error => {
    this.setState({
      isLoading: false
    });
    if (error.message) {
      displayError(error.message);
    } else {
      displayGenericError(error);
    }

  };

  handleCreateOrder = (onSuccess = () => null, onFailed = () => null) => {
    let requestedAmount =
      this.state.payment.transferMode === "SOURCE"
        ? this.state.payment.sourceValue.amount
        : this.state.payment.targetValue.amount;
    let orderStatus = this.state.accountStatus === "VERIFIED" ? this.state.orderStatus : null;
    let params = {
      id: this.state.order.id,
      sourceCurrency: this.state.payment.sourceValue.currency,
      targetCurrency: this.state.payment.targetValue.currency,
      requestedAmount: requestedAmount,
      lockedRateId: this.state.lockedExchangeRate.lockId,
      transferMode: this.state.payment.transferMode,
      beneficiaryId: this.state.beneficiary.id,
      selectedOriginatorVAId: this.state.selectedOriginatorVAId,
      originatorId: this.state.originator ? this.state.originator.id : null,
      purposeOfTransfer: this.state.purposeOfTransfer,
      referenceText: this.state.referenceText,
      internalReference: this.state.internalReference,
      noteToBeneficiary: this.state.noteToBeneficiary,
      orderStatus: orderStatus || null,
      noteToBeneficiaryText: this.state.noteToBeneficiaryText,
      beneficiaryCountry: this.state.payment.beneficiaryCountry,
      swiftFee: this.state.payment ? this.state.payment.swiftFee : null,
      activeTabFee: this.state.payment.activeTabFee,
      dbsChargeBearer: this.state.payment.dbsChargeBearer
    };
    createOrder(params)
      .then(onSuccess)
      .catch(onFailed);
  };

  onPaymentConfirmed = (orderStatus) => {
    this.setState({
      isLoading: true,
      orderStatus
    }, () => {
      this.handleCreateOrder(
        this.handleCreateOrderSuccess,
        this.handleCreateOrderFailed
      );
    });
  };

  onPurposeOfTransferChanged = (purposeOfTransfer) => {
    this.setState({
      purposeOfTransfer: purposeOfTransfer
    })
  }

  onBeneficiarySelected = (beneficiary, originator, selectedBeneficiaryVAId, selectedOriginatorVAId) => {
    this.setState({
      beneficiary: beneficiary,
      originator: originator,
      selectedBeneficiaryVAId: selectedBeneficiaryVAId,
      selectedOriginatorVAId: selectedOriginatorVAId,
    });
    this.selectTab("tab-setup-source-of-funds");
  };

  onPaymentCompleted = () => {
    this.selectTab("tab-payment-completed");
  };

  selectTab = tabName => {
    this.setState({
      activeTab: tabName
    });
  };

  handleMakePayment = () => {
    const intl = this.props.useIntl;
    const isVerified = this.state.accountStatus === "VERIFIED";
    if (isVerified) {
      this.onPaymentConfirmed("COMPLIANCE");
    } else {
      this.setState({ visible: true });
      if (!this.state.isSaved) {
        this.handleCreateOrder(
          () => message.success(intl.formatMessage({ id: "app.message.sendmoneypage.ordersaved" })),
          displayGenericError
        );
        this.setState({ isSaved: true });
      }
    }
  };

  handleCancel = () => {
    this.setState({
      visible: false
    });
  };

  onUploadInvoice = (file) => {
    let { order, isSaved } = this.state;
    let order_ = isSaved
      ? Promise.resolve(order)
      : new Promise((resolve, reject) => {
        this.handleCreateOrder(order => {
          resolve(order);
        }, error => {
          displayGenericError(error);
          reject(error);
        });
      })

    return order_.then(order => {
      const id = order.id;
      const fileType = 'CUSTOMER_PAYMENT_INVOICE';
      const otherTypeDescription = '';
      const remarks = 'Uploaded Invoice';
      this.setState({
        order: Object.assign(this.state.order, { id: id })
      })
      return uploadInvoice({
        id,
        fileType,
        otherTypeDescription,
        remarks,
        file
      })
        .then(response => {
          let invoice = response.filter(file => file.attachedFileType === 'CUSTOMER_PAYMENT_INVOICE');
          this.setState({
            invoiceUploading: false,
            invoiceFileName: invoice[0].name,
          });
          return invoice[0].name;
        })
        .catch(error => {
          displayGenericError(error);
        });
    })
  };

  handleStepClick = (stepIndex) => {  // <-- Added handler for step click
    const tabNames = ["tab-setup-amount", "tab-setup-beneficiary", "tab-setup-source-of-funds", "tab-confirm-payment", "tab-make-payment"];
    if (stepIndex <= TAB_GROUP[this.state.activeTab]) {
      this.setState({ activeTab: tabNames[stepIndex] });
    }
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingIndicator />;
    }

    const intl = this.props.useIntl;
    const { payment, accountStatus, currentCustomer } = this.state;

    return (
      <>
        {(accountStatus === "UNVERIFIED" ||
          accountStatus === "REVIEW_REQUIRED" ||
          accountStatus === "PENDING") && (
            <div className={"account-verify-status-bar"}>
              {accountStatus === "REVIEW_REQUIRED" ||
                accountStatus === "PENDING" ? (
                <>
                  <FormattedMessage id="app.message.sendmoneypage.submissionunderreview" />
                  <Link to="/pages/onboarding"><FormattedMessage id="app.page.sendmoneypage.reviewsubmission" /></Link>
                </>
              ) : (
                <>
                  <FormattedMessage id="app.message.sendmoneypage.accountnotverified" />{' '}
                  <Link to="/pages/onboarding"><FormattedMessage id="app.page.sendmoneypage.clickhere" /></Link>
                </>
              )}
            </div>
          )}
        <div className={"send-money-page"} key={this.state.key}>
          <CustomRxPageHeader customer={this.props.customer}
            title={intl.formatMessage({ id: "app.page.sendmoneypage.sendmoney" })}
          />

          <div className="bp-page-content">
            <h3>Send Money</h3>
            <h4>Send money to anyone, anywhere in the world</h4>
            <br></br>
            <ProgressBar current={TAB_GROUP[this.state.activeTab]} onStepClick={this.handleStepClick} />

            <br></br>


            {this.state.activeTab === "tab-setup-amount" && (
              <SetupPaymentTab
                onCompleted={this.onPaymentSetup}
                currentCustomer={this.state.currentCustomer}
                payment={this.state.payment}
                checkValidPayment={this.checkValidPayment}
                toCheckValidPayment = {this.toCheckValidPayment}
                disableContinue={this.state.disableContinue}
                updatePayment={this.updatePayment}
              />
            )}
            {this.state.activeTab === "tab-setup-beneficiary" && (
              <SetupBeneficiaryTab
                sourceCurrency={payment.sourceValue.currency}
                currency={payment.targetValue.currency}
                payment={this.state.payment}
                currentCustomer={this.state.currentCustomer}
                onCompleted={this.onBeneficiarySelected}
                onBack={() => this.selectTab("tab-setup-amount")}
              />
            )}
            {this.state.activeTab === "tab-setup-source-of-funds" && (
              <SetupSourceOfFundsTab
                payment={this.state.payment}
                onCompleted={this.onPaymentDetailsCompleted}
                onBack={() => this.selectTab("tab-setup-beneficiary")}
                onUploadInvoice={this.onUploadInvoice}
                onPurposeOfTransferChanged={this.onPurposeOfTransferChanged}
              />
            )}
            {this.state.activeTab === "tab-confirm-payment" && (
              <ConfirmPaymentTab
                payment={this.state.payment}
                exchangeRate={this.state.lockedExchangeRate}
                beneficiary={this.state.beneficiary}
                selectedBeneficiaryVAId={this.state.selectedBeneficiaryVAId}
                originator={this.state.originator}
                selectedOriginatorVAId={this.state.selectedOriginatorVAId}
                purposeOfTransfer={this.state.purposeOfTransfer}
                referenceText={this.state.referenceText}
                internalReference={this.state.internalReference}
                noteToBeneficiaryText={this.state.noteToBeneficiaryText}
                invoiceFileName={this.state.invoiceFileName}
                handleMakePayment={this.handleMakePayment}
                onCompleted={this.onPaymentConfirmed}
                onBack={() => this.selectTab("tab-setup-source-of-funds")}
              />
            )}
            {this.state.activeTab === "tab-make-payment" && (
              <MakePaymentTab
                payment={this.state.payment}
                order={this.state.order}
                currentCustomer={this.state.currentCustomer}
                onCompleted={this.onPaymentCompleted}
                visibility={this.state.visibility}
              />
            )}
            {this.state.activeTab === "tab-payment-completed" && (
              <PaymentCompletedTab
                payment={this.state.payment}
                onDoAnotherTransferClicked={this.onDoAnotherTransferClicked}
                onReturnToManageOrderClicked={this.onReturnToManageOrderClicked}
              />
            )}
            {this.state.errorMsg &&
              <div >
                <Alert style={{ display: "table", whiteSpace: "wrap", marginTop: "5px" }}
                  message={this.state.errorMsg} type="error" />
                <Alert style={{ display: "inline-block", whiteSpace: "wrap", marginTop: "5px" }}
                  message="Please contact support (operations@brdgx.com) for preferential rates and transfer procedure." type="error" />
              </div>
            }
          </div>
        </div>
        <CompliancePersonalInfoStatus visible={this.state.compliancePersonalInfoStatusVisible}
          customer={this.props.customer}
          onCancel={this.rejectConfirmPage}
          acceptConfirmPage={this.acceptConfirmPage} />
      </>
    );
  }
}

export default withUseIntl(SendMoneyPage);
